import placementsApi from "../../api/sites";

export default {
  namespaced: true,

  state: {
    sites: [],
    site: {},
    contacts: []
  },

  mutations: {
    SET_SITES(state, payload) {
      state.sites = payload;
    },
    SET_SITE(state, payload) {
      state.site = payload;
    },
    SET_CONTACTS(state, payload) {
      state.contacts = payload;
    }
  },

  actions: {
    getSites(context) {
      return new Promise((resolve, reject) => {
        placementsApi
          .getSitesWithNoOpportunity()
          .then(function(response) {
            context.commit("SET_SITES", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    getSite(context, siteId) {
      return new Promise((resolve, reject) => {
        placementsApi
          .getSite(siteId)
          .then(function(response) {
            context.commit("SET_SITE", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    getSiteSupervisors(context, siteId) {
      return new Promise((resolve, reject) => {
        placementsApi
          .getSiteSupervisors(siteId)
          .then(function(response) {
            context.commit("SET_CONTACTS", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    getSiteSupervisorsByStudentOpportunity(context, studentOpportunityId) {
      return new Promise((resolve, reject) => {
        placementsApi
          .getSiteSupervisorsByStudentOpportunity(studentOpportunityId)
          .then(function(response) {
            context.commit("SET_CONTACTS", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    }
  }
};
